import { Tabs } from "antd"
import Users from "./Users";
import Profiles from "./Profiles";
import DirectorySynchro from './DirectorySynchro'
import TabExtraContent from "../common/TabExtraContent";
import { useDispatch, useSelector } from "react-redux";
import { setContentLoading, setCurrentMergedData, setExtraContent } from "../../store/reducers/CommonReducer";
import { getTranslated } from "../../utils/CommonUtils";
import { useEffect, useState } from "react";
import { DSS, GROUPS, PROFILES, USERS, DIRECTORY_SYNCHRO } from "../../utils/Constants";
import { ENV, PROD, QA, QA_BETA } from "../../utils/Config";
import confirmModal from "../common/confirmModal";
import DesktopSharing from "./DesktopSharing";
import Groups from "./Groups";
import { deleteDECTOnTabChange, getProfileList, getUsersList, getUsersList2, getGroupList, getHuntGroupList, getDirectorySynchroUserList } from "../../store/actions/UUMActions";
import { getProgKeysProfList } from "../../store/actions/ProgKeysAction";
import { setDirectorySynchroTableList } from "../../store/reducers/UUMReducer"
import { sendGTMEvent } from "../../utils/GTMUtils";

const UsersConfig = (props) => {

    const [selectedTab, setSelectedTab] = useState(USERS)

    const dict = useSelector((state) => state.common.dict)
    const language = useSelector((state) => state.common.language)
    const isUserProfileTab = useSelector((state) => state.uum.isUserProfileTab)
    const isPickupGroupTab = useSelector((state) => state.uum.isPickupGroupTab)
    const extraContent = useSelector((state) => state.common.extraContent)
    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const baseMergeData = useSelector((state) => state.common.baseMergeData)
    const validateForDECTUserDelete = useSelector((state) => state.uum.validateForDECTUserDelete)
    const isUnSavedDataExists = useSelector((state) => state.common.isUnSavedDataExists)
    const directorySynchroConfigData = useSelector((state) => state.uum.directorySynchroConfigData)

    const dispatch = useDispatch()

    const items = [
        {
            key: USERS,
            label: getTranslated(dict, "LABEL_USERS"),
            children: <Users />,
        },
        {
            key: DSS,
            label: getTranslated(dict, "LABEL_DESK_SHARING"),
            children: (ENV === PROD || ENV === QA || ENV === QA_BETA) ? 'Under development...' : <DesktopSharing />,
            disabled: true,
        },
        {
            key: PROFILES,
            label: getTranslated(dict, "LABEL_PROFILES"),
            children: <Profiles />,
        },
        {
            key: GROUPS,
            label: getTranslated(dict, "LABEL_GROUPS"),
            children: <Groups />,
        },
        (directorySynchroConfigData?.response?.length !== 0) ?
            {
                key: DIRECTORY_SYNCHRO,
                label: getTranslated(dict, "LABEL_DIRECTORY_SYNCHRO"),
                children: <DirectorySynchro />,
            } : ""
    ]

    useEffect(() => {
        sendGTMEvent({
            event: "umc_tab_selection",
            selected_item: selectedTab
        })
    }, [selectedTab])

    const handleRefresh = () => {

        switch (selectedTab) {
            case USERS:
                dispatch(setContentLoading(true))
                // dispatch(getUsersList())
                dispatch(getUsersList(() => {
                    // dispatch(setContentLoading(false)) 
                    dispatch(getUsersList2())
                }))
                break
            case DSS:
                break
            case PROFILES:
                dispatch(setContentLoading(true))
                dispatch(isUserProfileTab ? getProfileList() : getProgKeysProfList())
                break
            case GROUPS:
                dispatch(setContentLoading(true))
                dispatch(isPickupGroupTab ? getGroupList() : getHuntGroupList())
                break
            case DIRECTORY_SYNCHRO:
                dispatch(setContentLoading(true))
                dispatch(getDirectorySynchroUserList(setDirectorySynchroTableList))
                break
            default:
                break
        }
    }

    const handleHelpReq = () => {
        const src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc-easy-user-management.html`
        switch (selectedTab) {
            case USERS:
                window.open(`${src}#user-config`, "_blank")
                break
            case DSS:
                window.open(`${src}#ariaid-title10`, "_blank")
                break
            case PROFILES:
                window.open(`${src}#user-profiles`, "_blank")
                break
            case GROUPS:
                window.open(`${src}${isPickupGroupTab?'#topic_tym_yy3_1gc':'#topic_enj_ttm_2cc'}`, "_blank")
                break
            case DIRECTORY_SYNCHRO:
                window.open(`${src}#directory-synchro`, "_blank")
                break
            // DS - #directory-synchro
            default:
                break
        }
    }

    const handleTabChange = (key) => {
        if (currentMergedData && isUnSavedDataExists) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    if (validateForDECTUserDelete) {
                        dispatch(deleteDECTOnTabChange(() => {
                            dispatch(setCurrentMergedData(null))
                            setSelectedTab(key)
                        }))
                    } else {
                        dispatch(setCurrentMergedData(null))
                        setSelectedTab(key)
                    }
                }
            })
        }
        else {
            dispatch(setExtraContent([]))
            setSelectedTab(key)
        }
    }


    return <Tabs
        type="card"
        className={`tab-common custom-tab`}
        activeKey={selectedTab}
        tabBarExtraContent={<TabExtraContent
            handleRefresh={handleRefresh}
            handleHelpReq={handleHelpReq}
            selectedTab={selectedTab}
            contentItems={extraContent}
        />}
        items={items}
        destroyInactiveTabPane={true}
        onTabClick={(key) => (key !== selectedTab) && handleTabChange(key)}
        animated={{ inkBar: true, tabPane: true }}
    />
}

export default UsersConfig